export const SET_TYPE = 'featureAccess/SET_TYPE';

export const FETCH_FEATURE_ACCESS_REQUEST = 'featureAccess/FETCH_FEATURE_ACCESS_REQUEST';
export const FETCH_FEATURE_ACCESS_SUCCESS = 'featureAccess/FETCH_FEATURE_ACCESS_SUCCESS';
export const FETCH_FEATURE_ACCESS_FAILURE = 'featureAccess/FETCH_FEATURE_ACCESS_FAILURE';
export const SHOW_FEATURE_MODAL = 'featureAccess/SHOW_FEATURE_MODAL';
export const DISMISS_FEATURE_MODAL = 'featureAccess/DISMISS_FEATURE_MODAL';
export const SET_ORG = 'featureAccess/SET_ORG';
